import { IForm } from '@/components/types'

export const modalConfig: IForm = {
  formItems: [
    {
      field: 'keyword',
      type: 'input',
      label: '关键词',
      placeholder: '请输入关键词',
      rules: { required: true, message: '关键词是必传的', trigger: 'blur' }
    },
    {
      field: 'eventsId',
      type: 'select',
      label: '直播间',
      placeholder: '请选择直播间',
      rules: {
        required: true,
        message: '直播间是必传的',
        trigger: 'blur'
      }
    },
    {
      field: 'addTime',
      type: 'timePicker',
      label: '时间范围',
      rules: { required: true, message: '时间范围是必传的', trigger: 'blur' }
    }
  ],
  colLayout: 24,
  itemStyle: {}
}
